<div
  class="ad-banner-editor-click-area d-flex justify-content-center"
  [ngStyle]="style"
  (mousedown)="$event.preventDefault();$event.stopPropagation();"
>
  <div
    *ngIf="!url && !editingUrl"
    (click)="editingUrl = !url ? true : editingUrl"
    class="ad-banner-editor-click-area__inner"
    [ngbTooltip]="'banner.clickToEdit' | translate"
    placement="bottom"
    [disableTooltip]="editingUrl || draggedHandle !== undefined"
  ></div>
  <div *ngIf="!editingUrl" class="ad-banner-editor-click-area__url" (click)="editingUrl = true">
    {{url}}
  </div>
  <div
    *ngIf="editingUrl"
    class="ad-banner-editor-click-area__url ad-banner-editor-click-area__url--editing d-flex justify-content-between"
  >
    <input
      [(ngModel)]="url"
      type="text"
      [placeholder]="'banner.link' | translate"
      autofocus
      (mousedown)="$event.stopPropagation()"
      (mousemove)="$event.stopPropagation()"
    />
    <button
      type="button"
      class="btn btn-overlay ml-2 ad-banner-editor-click-area__save-button"
      (click)="saveUrl($event)"
      (mousedown)="$event.stopPropagation()"
      (mouseup)="$event.stopPropagation()"
    >
      <svg-icon icon="save"></svg-icon>
    </button>
  </div>
  <div
    *ngIf="!editingUrl"
    class="ad-banner-editor-click-area__handle ad-banner-editor-click-area__handle--top"
    (mousedown)="onTopHandlePressed($event)"
  ></div>
  <div
    *ngIf="!editingUrl"
    class="ad-banner-editor-click-area__handle ad-banner-editor-click-area__handle--bottom"
    (mousedown)="onBottomHandlePressed($event)"
  ></div>
  <!--  </div>-->

  <div class="ad-banner-editor-click-area__delete-button-container">
    <div class="ad-banner-editor-click-area__delete-button">
      <button
        type="button"
        class="btn btn-overlay"
        (click)="onDeleteButtonClick($event)"
        (mousedown)="$event.stopPropagation()"
        (mouseup)="$event.stopPropagation()"
      >
        <svg-icon icon="delete"></svg-icon>
      </button>
    </div>
  </div>
</div>
